export const DEFAULT_KARGONOMI_SETTINGS = {
  enabled: false,
  apiToken: '',
  apiTokenSet: false,
  warehouseId: '',
  autoPickCheapest: true,
  webhookSecret: '',
  webhookSecretSet: false,
  ready: false
};

export const normalizeKargonomiSettings = (raw = {}) => ({
  enabled: raw.enabled === true,
  apiToken: String(raw.apiToken || '').trim(),
  apiTokenSet: raw.apiTokenSet === true || Boolean(String(raw.apiToken || '').trim()),
  warehouseId: String(raw.warehouseId || '').trim(),
  autoPickCheapest: raw.autoPickCheapest !== false,
  webhookSecret: String(raw.webhookSecret || '').trim(),
  webhookSecretSet: raw.webhookSecretSet === true || Boolean(String(raw.webhookSecret || '').trim()),
  ready: raw.ready === true
});
